import { render, staticRenderFns } from "./TheCartCuratorPanel.vue?vue&type=template&id=0d72e07b&scoped=true&"
import script from "./TheCartCuratorPanel.vue?vue&type=script&lang=js&"
export * from "./TheCartCuratorPanel.vue?vue&type=script&lang=js&"
import style0 from "./TheCartCuratorPanel.vue?vue&type=style&index=0&id=0d72e07b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d72e07b",
  null
  
)

export default component.exports